const state = {
  ativar_dialog_count: 0,
  exportacao_sankha: {
    exclusao_produto: {}
  }
}

const getters = {
  ativar_dialog_count(state) {
    return state.ativar_dialog_count
  },
  resultado_exportacao_sankha(state) {
    return state.exportacao_sankha
  },
  resultado_exclusao_produto_sankhya(state) {
    return state.exportacao_sankha.exclusao_produto
  },
}

const mutations = {
  ativar_dialog_count(state){
    state.ativar_dialog_count += 1
  },
  resultado_exclusao_produto_sankhya(state, valor){
    state.exportacao_sankha.exclusao_produto = valor
  }
}

const actions = {
  ativar_dialog_count: ({ commit }) => {
    commit("ativar_dialog_count")
  },
  resultado_exclusao_produto_sankhya: ({ commit }, valor) => {
    commit("resultado_exclusao_produto_sankhya", valor)
  }
}

export default { namespaced: true, state, mutations, getters, actions }
